import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import "./Slider.scss"
import queryString from "query-string";
import dataJSON from "../../../static/api/data.json";

export default class Slider extends Component {
    constructor() {
        super();
        this.state = {
            month: 0,
            Selected: {}
        }
    }
    shouldComponentUpdate(props, state) {
        return false;
    }
    componentDidMount() {
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('resize');
        } else {
            event = document.createEvent('Event');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
        (this.props.setOwlRef ? this.props.setOwlRef(this.owl) : null)
    }
    startPos() {
        try {
            const hash = queryString.parse(window.location.hash.toLocaleLowerCase());
            const isMonthActive = [
                ["january", 0],
                ["february", 1],
                ["march", 2],
                ["april", 3],
                ["may", 4],
                ["june", 5],
                ["july", 6],
                ["august", 7],
                ["september", 8],
                ["october", 9],
                ["november", 10],
                ["december", 11]
            ].filter(m => m[0] == Object.keys(hash)[0])[0][1];
            if (dataJSON[isMonthActive].length != 0) {
                return isMonthActive > 0 ? isMonthActive - 2 : isMonthActive;
            }
        } catch (e) {
            return 0;
        }
    }
    render() {
        return (
            <OwlCarousel
                className={`owl-theme`}
                startPosition={this.startPos()}
                margin={0}
                nav={true}
                navSpeed={600}
                lazyLoad={true}
                dots={false}
                autoWidth={false}
                responsiveClass={true}
                loop={true}
                ref={(owl) => this.owl = owl}
                navText={["", ""]}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                responsive={this.props.responsive ? this.props.responsive : {
                    800: {
                        items: 4,
                        slideBy: 4,
                        center: false,
                        autoWidth: true,
                        rtl: true,
                        nav: false
                    }
                }}
            >
                {this.props.children}
            </OwlCarousel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Helpers/Slider/Slider.jsx